<template>
  <v-skeleton-loader v-if="loading"
                     type="card"/>
  <content-card v-else
                :title="$t('device-favorites-card.title').toString()"
                icon="favorite">
    <template v-slot:content>
      <div v-for="device in favoriteDevices" v-bind:key="device.id">
        <generic-device-card :device="device"
                             class="list-item"
                             dense flat/>
      </div>
    </template>
  </content-card>
</template>

<script>

import ContentCard from "@/templates/components/ContentCard";
import GenericDeviceCard from "@/templates/components/devices/GenericDeviceCard.vue";

export default {
  name: 'DeviceFavoritesCard',

  components: {
    GenericDeviceCard,
    ContentCard
  },

  data: () => ({
        loading: false,
        favoriteDevices: []
      }
  ),

  methods: {
    getFavoriteDevices(showError) {
      this.loadCachedData()
      this.$rhRequest.sendGet({
        endpoint: "devices/get-app-favorites-device-ids"
      }, (resp) => {
        let ids = resp?.data?.data
        if (resp?.data?.code === -1 || !ids || ids?.length === 0) {
          this.loading = false
        } else {
          this.$rhRequest.sendGet({
            endpoint: 'devices/get',
            params: {
              deviceIds: ids.join(',')
            }
          }, (resp) => {

            this.favoriteDevices = Array.from(Object.values(resp?.data?.data))
            this.loading = false
          }, (err) => {
            console.error(err)
          })
        }
      }, (err) => {
        console.error(err)
        if (showError) { // do not spam
          this.$root.bisatoast.error({message: this.$t('app.generic-error'), showCloseBtn: true})
        }
        console.log('Error getting favorite devices')
        this.loading = false
      })
    },
    loadCachedData() {
      this.$caching.getData('favoriteDevices').then(data => {
        if (data !== -1) {
          if (!data) {
            this.favoriteDevices = []
            this.loading = false
          }  else {
            this.favoriteDevices = data
          }
        }
      })
    }
  },
  watch: {
    favoriteDevices(newVal) {
      this.$caching.saveData('favoriteDevices', newVal)
      
      if (!this.favoriteDevices || this.favoriteDevices.length === 0) {
        this.$emit('hide-favorites', true)
      } else {
        this.$emit('hide-favorites', false)
      }
    }
  }
}
</script>
